import { cn } from '~/shadcn/lib/utils'
import { CurrencyFormatter } from '~/@mid_ui/currency-formatter/CurrencyFormatter'

type Props = {
  value: number
  hideCurrency?: boolean
  className?: string
  integerClassName?: string
  decimalClassName?: string
}

function InvestmentAttributeCurrency({
  className,
  integerClassName,
  decimalClassName,
  ...props
}: Props) {
  return (
    <CurrencyFormatter
      className={cn(
        'text-icon-default text-sm lg:text-xl font-semibold self-center',
        className
      )}
      integerClassName={cn(
        'text-icon-default text-sm lg:text-xl',
        integerClassName
      )}
      decimalClassName={cn(
        'text-icon-default text-sm lg:text-sm',
        decimalClassName
      )}
      {...props}
    />
  )
}

export { InvestmentAttributeCurrency }
